/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from "../../icetypes";

export class purchaseorderservice extends IceEntity {
  purchase_order_service_key: string = "";
  other_items_key: string = "";
  medical_service_key: string = "";
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  trans_account: string = "";
  date_of_service: any = NaN;
  service_abstract: string = "";
  po_num: string = "";
  quantity: number = 0.0;
  unit_type: string = "";
  ap_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  sal_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  cst_ser_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  tax_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  sal_payable_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  tax_payable_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  cost: number = 0.0;
  tracking_num: string = "";
  rec_notes: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "PURCHASE_ORDER_SERVICE";
  }
}
